<template>
	<div>
		<h1 class="teaser">Jetzt dein skilldoo-Profil anlegen und kostenfrei nutzen</h1>
		<div class="tag-sections">
			<section class="tag">
				<h2>{{ title }}</h2>
				<CharacteristicSelectInline
					v-model="employmentModes"
					:characteristic-items="meta.employmentMode"
					initial-show-all
					label-type="application"
					show-multiple-hint
					@input="emitChangeEvent"
				/>
			</section>
			<section class="tag">
				<h2>Wären für dich spezielle Arbeitszeiten in Ordnung?</h2>
				<CharacteristicSelectInline
					v-model="workingTimes"
					:characteristic-items="meta.workingTime"
					:nothing-allowed="{
						text: 'Nein, keine speziellen Arbeitszeiten'
					}"
					initial-show-all
					label-type="application"
					show-multiple-hint
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import CharacteristicEdit from "@/vue/characteristic/Edit"
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline"

import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {

	components: {
		CharacteristicEdit,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			employmentModes: this.value?.employmentModes,
			workingTimes: this.value?.workingTimes,
		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		employmentModesValid ()
		{
			return isDefined(this.employmentModes) && arrayIsNotEmpty(this.employmentModes);
		},
		workingTimesValid ()
		{
			return isDefined(this.workingTimes);
		},
		valid ()
		{
			return this.workingTimesValid
				&& this.employmentModesValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				employmentModes: this.employmentModes,
				workingTimes: this.workingTimes,
				valid: this.valid
			});
		}
	}
}
</script>
